import type { KeyArgsFunction } from '@apollo/client/cache/inmemory/policies';

export const defaultKeyArgsFn = (): KeyArgsFunction => {
  function computeKeyObject(args: Record<string, unknown>) {
    return (
      Object.entries(args)
        .filter(([k]) => k !== 'offset' && k !== 'limit')
        // The order of adding properties to keyObj affects its JSON serialization
        .sort((a, b) => a[0].localeCompare(b[0]))
        .reduce((previousValue: Record<string, unknown>, [k, v]) => ({ ...previousValue, [k]: v }), {})
    );
  }

  return (args, context) => {
    return args ? `${context.fieldName}:${JSON.stringify(computeKeyObject(args))}` : context.fieldName;
  };
};
